import { type CardProps, Card as _Card } from 'antd';

import { StyledCard } from './Card.style';

export function Card(props: CardProps) {
  return <StyledCard {...props} />;
}

export const Meta = _Card.Meta;
